import type { UsersListRow } from "@/admin/entities/users";
import type { UserOrganizationsListRow } from "@/admin/entities/organizationUsers";
import type { UserRoleInfo, UserPlatformInfo } from "./types";
import type { UsersListQueryType } from "@/types/graphql/admin.generated";

/**
 * Мапперы для feature управления пользователями
 * Используют конкретные типы из GraphQL кодгена
 */

// Трансформация данных GraphQL ответа в формат для таблицы
// CRUD компонент ожидает (data: unknown) => TableData<Row>
export function getTableData(data: unknown): {
  nodes: UsersListRow[];
  count: number;
} {
  const typedData = data as UsersListQueryType;
  const res = typedData?.users;

  if (!res || !res.nodes) {
    return { nodes: [], count: 0 };
  }

  return {
    nodes: res.nodes,
    count: res.count,
  };
}

// Маппинг данных пользователя в формат для отображения в таблице
export function mapColumns(user: UsersListRow) {
  const roleInfo: UserRoleInfo = {
    isAdmin: user.isAdmin,
    isSuperAdmin: user.isSuperAdmin,
    isPartner: user.isPartner,
    isPlatformAdmin: user.isPlatformAdmin,
  };
  const platformInfo: UserPlatformInfo = {
    platformId: user.platformId,
    platform: user.platform,
  };

  return [
    user.id,
    user, // для кастомного рендера имени
    user.phone,
    roleInfo,
    platformInfo,
    user.createdAt,
  ];
}

// Маппинг для вкладки "Организации" на странице юзера
export function mapUserOrganizationsColumns(row: UserOrganizationsListRow) {
  return [row.id, row, row, row.createdAt];
}
